export { TrustSeals } from './TrustSeals';
